var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BEEBFA"
    },
    points: "271,482 271,209.995 241,209.995 241,482 142.585,482 142.585,512 369.415,512 369.415,482  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9001C"
    },
    d: "M236.105,37.618l20.016,220.039c81.248-0.066,147.092-65.948,147.092-147.211v-2.789 C403.213,62.331,299.995,41.649,236.105,37.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF1F3E"
    },
    d: "M256.116,47.625c-63.945-4.035-147.087-14.973-147.087,40.003c-0.152,3.726-0.242,7.457-0.242,11.192 v11.625c0,81.303,65.909,147.213,147.213,147.213l0,0c0.04,0,0.08-0.001,0.121-0.001V47.626 C256.118,47.625,256.117,47.625,256.116,47.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEEBFA"
    },
    d: "M384.745,0H256.121l-20.016,47.626l20.016,49.953c13.62-5.388,27.282-10.759,54.521-10.759 c48.414,0,53.945,16.965,92.572,20.836V98.82C403.213,65.022,396.951,31.517,384.745,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1F4FA"
    },
    d: "M127.255,0c-10.857,28.033-16.998,57.641-18.226,87.628c38.396,3.92,44.008,20.811,92.314,20.811 c27.411,0,41.073-5.439,54.778-10.86V0H127.255z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWine);
export default __webpack_public_path__ + "static/media/icon-wine.a1e713eb639b2154c76dbd350135b72f.svg";
export { ForwardRef as ReactComponent };